import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { TCrmRestrictionsItem } from '../../../types';
import Text, { TEXT } from '~/view/components/Text/Text';
import { SCREENS } from '~/constants/screens';
import './style.scss';
import { historyPushWithSaveBackPath } from '~/helpers';
import { formatDate, getPaymentMethodIcon } from '~/utils/helpers';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import { confirmDelete } from '~/utils/modalConfirmations';
import { localeStore } from '~/mobx/localesStore';
import { crmRestrictionsStore } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/store';

interface CrmRestrictionsListRowProps {
  data: TCrmRestrictionsItem;
}

const CrmRestrictionsListRow = ({ data }: CrmRestrictionsListRowProps) => {
  const onDelete = () => {
    confirmDelete({
      message: localeStore.t('confirm_deleting_crm_restriction'),
      onConfirm: () => data && crmRestrictionsStore.deleteRestriction(data.id),
      redConfirmBtn: true,
    });
  };

  const handleOpenProfile: React.MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
    e.preventDefault();
    historyPushWithSaveBackPath(SCREENS.CRM_PROFILE_EDIT(data.userId));
  }, []);

  return (
    <div className="crm-restrictions-list-row crm-restrictions-list-row__grid-template mr-4">
      <div className="crm-restrictions-list-row__element">
        <Link onClick={handleOpenProfile} to="#" className="color-mainblue text-size-16 family-medium">
          {data.userPhone}
        </Link>
      </div>
      <div className="crm-restrictions-list-row__element">
        <Icon name={getPaymentMethodIcon(data.paymentType)} size={24} />
      </div>
      <div className="crm-restrictions-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.comment} noTranslate />
      </div>
      <div className="crm-restrictions-list-row__element">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={data.disabledBy} noTranslate />
      </div>
      <div className="crm-restrictions-list-row__element crm-restrictions-list-row__dates">
        <Text dir="ltr" type={TEXT.LIST_ROW} text={formatDate(data.disabledAt, {})} noTranslate />
      </div>
      <div className="crm-restrictions-list-row__element">
        <Icon
          name={Icons.Trash}
          size={24}
          disabled={crmRestrictionsStore.loading}
          className="crm-restrictions-list-row__btn crm-restrictions-list-row__btn-delete ml-4"
          disabledClassName="crm-restrictions-list-row__btn_disabled"
          onPress={onDelete}
        />
      </div>
    </div>
  );
};

export default CrmRestrictionsListRow;
